import { render, staticRenderFns } from "./MoneyBackGuaranteeDialog.vue?vue&type=template&id=6a72bf4c"
import script from "./MoneyBackGuaranteeDialog.vue?vue&type=script&lang=ts"
export * from "./MoneyBackGuaranteeDialog.vue?vue&type=script&lang=ts"
import style0 from "./MoneyBackGuaranteeDialog.vue?vue&type=style&index=0&id=6a72bf4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@7.1.2_@rspack+core@2.1.8_webpack_6b8fc1273ff717b8f145294df5db1f84/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports